const courses = [
  {
    title: 'Physics of Complex Systems',
    number: 'SIO 216A',
    link: 'https://scripps.ucsd.edu/sites/scripps.ucsd.edu/files/basic-page-education/field_attachment/2016/SIO216%20WI16%20Werner.pdf',
    university: 'UCSD',
  }, {
    title: 'Physics of Complex Systems',
    number: 'SIO 216B',
    link: 'https://scripps.ucsd.edu/sites/scripps.ucsd.edu/files/basic-page-education/field_attachment/2016/SIO216%20WI16%20Werner.pdf',
    university: 'UCSD',
  },{
    title: 'Foundations of Population Dynamics',
    number: 'SIO 276B',
    link: 'https://scripps.ucsd.edu/sites/scripps.ucsd.edu/files/basic-page-education/field_attachment/2017/SIOB%20276%20FA17%20Sugihara.pdf',
    university: 'UCSD',
  }, 
];

export default courses;
